import styled, { css } from 'styled-components';

import { mediaDesktop } from 'breakpoints';
import Typography from 'components/Typography';

export const SelectContainer = styled.div`
  user-select: none;
  font-family: ${({ theme }) => theme.fonts.primary};
  background: ${({ theme }) => theme.colors.transparent};
  width: 100%;
  border: 1px solid #fff;
  color: ${({ theme }) => theme.colors.white};
  position: relative;
  height: 45px;

  & p {
    font-size: 16px;
  }

  ${mediaDesktop} {
    height: 60px;

    & p {
      font-size: 24px;
    }
  }
`;

export const SelectHeader = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  padding-left: 12px;
  display: flex;
  align-items: center;
`;

export const SelectOptionsList = styled.div<{ isOpen: boolean }>`
  position: absolute;
  top: 100%;
  display: grid;
  left: calc(0% - 1px);
  right: calc(0% - 1px);
  border: 1px solid #fff;
  transition: all 0.3s;
  z-index: 2;

  ${({ isOpen }) => !isOpen
    && `
      display: none;
      height: 0;
    `}
`;

export const SelectOption = styled.div`
  background: ${({ theme }) => theme.colors.dark};
  transition: all 0.3s;
  padding: 12px;
  cursor: pointer;
  z-index: 2;

  &:hover {
    background: #fff;
    color: black;
  }
`;

export const SelectArrow = styled.div`
  width: 11px;
  height: 11px;
  position: absolute;
  top: 50%;
  left: calc(100% - 32px);
  border-right: 1px solid #fff;
  border-bottom: 1px solid #fff;
  transform: translateY(calc(-50% - 3px)) rotate(45deg);

  ${mediaDesktop} {
    width: 15px;
    height: 15px;
    left: calc(100% - 40px);
    border-right: 2px solid #fff;
    border-bottom: 2px solid #fff;
  }
`;

const popUpCss = css`
  & > ${Typography} {
    color: #fff;
    ${mediaDesktop} {
      font-size: 16px;
    }
  }
  & ${SelectContainer} {
    & * {
      ${mediaDesktop} {
        font-size: 13px;
        text-transform: uppercase;
        font-weight: 600;
        letter-spacing: 2.5px;
      }
    }
    ${mediaDesktop} {
      height: 48px;
    }
  }

  ${mediaDesktop} {
    grid-gap: 8px;
  }
`;

export const SelectWrapper = styled.div<{ popUpVersion?: boolean }>`
  display: grid;
  grid-gap: 6px;

  ${mediaDesktop} {
    grid-gap: 14px;
  }

  ${({ popUpVersion }) => (popUpVersion && popUpCss)}
`;
